<template>
  <el-dialog title="网关配置"
             :visible.sync="showModal"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-row>
      <el-form :model="channelInfo"
               :rules="channelRules"
               ref="channelForm"
               label-width="160px"
               class="channel-form">
        <el-form-item label="通道号："
                      prop="channelId">
          <el-select class="ml-10"
                     v-model="channelInfo.channelId"
                     placeholder="请选择通道号"
                     @change="changeChanne">
            <el-option label="1"
                       value="1"></el-option>
            <el-option label="2"
                       value="2"></el-option>
            <el-option label="3"
                       value="3"></el-option>
            <el-option label="4"
                       value="4"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-form :model="testInfo"
               :disabled="!channelInfo.channelId"
               :rules="testRules"
               ref="testForm"
               label-width="156px"
               class="test-form">
        <el-form-item label="频率(kHz)："
                      prop="Frequency">
          <el-input-number class="price-input"
                           v-model="testInfo.Frequency"
                           :min="410000"
                           :max="725000"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="空中速率(kbps)："
                      prop="SpeedRate">
          <el-select v-model="testInfo.SpeedRate"
                     placeholder="请选择空中速率">
            <el-option v-for="item in speedRateList"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发射功率(dBm)："
                      prop="RadioPower">
          <el-input-number class="price-input"
                           v-model="testInfo.RadioPower"
                           :min="-1"
                           :max="20"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="串口速率(bps)："
                      prop="ComSpeed">
          <el-select v-model="testInfo.ComSpeed"
                     placeholder="请选择空中速率">
            <el-option v-for="item in comSpeedList"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="串口校验方式："
                      prop="ComCheck">
          <el-select v-model="testInfo.ComCheck"
                     placeholder="请选择串口校验方式">
            <el-option label="无校验"
                       value="00"></el-option>
            <el-option label="奇校验"
                       value="01"></el-option>
            <el-option label="偶校验"
                       value="02"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="唤醒周期(ms)："
                      prop="AwakenTime">
          <el-input-number class="price-input"
                           v-model="testInfo.AwakenTime"
                           :min="50"
                           :max="10000"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="触发延时(ms)："
                      prop="TriggerDelay">
          <el-input-number class="price-input"
                           v-model="testInfo.TriggerDelay"
                           :min="5"
                           :max="1000"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="载波监听时间(ms)："
                      prop="CarrierTime">
          <el-input-number class="price-input"
                           v-model="testInfo.CarrierTime"
                           :min="100"
                           :max="20000"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="无线数据包长(Byte)："
                      prop="WirelessPkgLen">
          <el-input-number class="price-input"
                           v-model="testInfo.WirelessPkgLen"
                           :min="1"
                           :max="255"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="硬件地址："
                      prop="DeviceAddr">
          <el-input v-model.trim="testInfo.DeviceAddr"
                    placeholder="请输入硬件地址（0~6，a~f, A~F）"></el-input>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="8"
                  :sm="12"
                  :xs="24">
            <el-form-item label="定长帧模式："
                          prop="FB_FixedFrame">
              <el-switch v-model="testInfo.FB_FixedFrame"
                         active-color="#13ce66"
                         inactive-color="#dcdfe6"
                         active-value="1"
                         inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8"
                  :sm="12"
                  :xs="24">
            <el-form-item label="场强检测："
                          prop="FB_FieldStrength">
              <el-switch v-model="testInfo.FB_FieldStrength"
                         active-color="#13ce66"
                         inactive-color="#dcdfe6"
                         active-value="1"
                         inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8"
                  :sm="12"
                  :xs="24">
            <el-form-item label="载波侦听："
                          prop="FB_CarrierSense">
              <el-switch v-model="testInfo.FB_CarrierSense"
                         active-color="#13ce66"
                         inactive-color="#dcdfe6"
                         active-value="1"
                         inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8"
                  :sm="12"
                  :xs="24">
            <el-form-item label="硬件地址使能："
                          prop="FB_DevAddrEnable">
              <el-switch v-model="testInfo.FB_DevAddrEnable"
                         active-color="#13ce66"
                         inactive-color="#dcdfe6"
                         active-value="1"
                         inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8"
                  :sm="12"
                  :xs="24">
            <el-form-item label="发送源地址使能："
                          prop="FB_SrcAddrEnable">
              <el-switch v-model="testInfo.FB_SrcAddrEnable"
                         active-color="#13ce66"
                         inactive-color="#dcdfe6"
                         active-value="1"
                         inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8"
                  :sm="12"
                  :xs="24">
            <el-form-item label="低功耗休眠："
                          prop="FB_LowPowerSleep">
              <el-switch v-model="testInfo.FB_LowPowerSleep"
                         active-color="#13ce66"
                         inactive-color="#dcdfe6"
                         active-value="1"
                         inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/gate/setLora'"
                 type="primary"
                 @click="handleConfirm('testForm')">
        写 入
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      channelInfo: {
        channelId: ''
      },
      channelRules: {
        channelId: [{ required: true, message: '请选择通道号' }]
      },
      testInfo: {
        Frequency: '',
        SpeedRate: '',
        RadioPower: '',
        ComSpeed: '',
        ComCheck: '',
        AwakenTime: '',
        TriggerDelay: '',
        CarrierTime: '',
        WirelessPkgLen: '',
        DeviceAddr: '',
        FB_FixedFrame: '',
        FB_FieldStrength: '',
        FB_CarrierSense: '',
        FB_DevAddrEnable: '',
        FB_SrcAddrEnable: '',
        FB_LowPowerSleep: ''
      },
      testRules: {
        Frequency: [{ required: true, message: '请输入频率' }],
        SpeedRate: [{ required: true, message: '请输入波特率' }],
        RadioPower: [{ required: true, message: '请输入发射功率' }],
        ComSpeed: [{ required: true, message: '请选择串口速率' }],
        ComCheck: [{ required: true, message: '请输入发射功率' }],
        AwakenTime: [{ required: true, message: '请输入发射功率' }],
        TriggerDelay: [{ required: true, message: '请输入发射功率' }],
        CarrierTime: [{ required: true, message: '请输入发射功率' }],
        WirelessPkgLen: [{ required: true, message: '请输入发射功率' }],
        DeviceAddr: [{ required: true, message: '请输入发射功率' }]
      },
      comSpeedList: ['1200', '2400', '4800', '9600', '19200', '38400', '57600', '115200'],
      speedRateList: [
        '50.78',
        '61.04',
        '81.45',
        '122.07',
        '244.14',
        '406.9',
        '813.8',
        '1464.84',
        '1790.36',
        '2604.17',
        '3255.21',
        '4557.29',
        '5859.38',
        '10416.67',
        '18229.17',
        '31250'
      ]
    }
  },
  methods: {
    // 获取编辑信息
    getInfo(val) {
      fetch.getLoraGate({ id: this.data.id, sn: this.data.sn, channelId: val }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.testInfo = data.lora
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 切换通道
    changeChanne(val) {
      this.getInfo(val)
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch
            .setLoraGate({
              ...this.testInfo,
              ...this.channelInfo,
              id: this.data.id,
              sn: this.data.sn
            })
            .then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.$emit('handleClose')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style></style>
